export const enum ApplicationType {
    Therapy = '1',
    WoundCare = '2',
}

export const enum PreferenceModule {
    Worklist = '1',
    Scheduler = '2',
    ManagementBoard = '3',
    VisitWorklist = '4',
    ClaimsDashboard = '5',
    ClaimDashboardWidget = '6',
    VisitReminder = '7',
    SchedulerConfig = '8',
    AccountBalWriteoff = '9',
    PaymentBatches = '10'
}
